export const waitForKameleoon = () => {
  return new Promise((resolve, reject) => {
    let nbIterations = 0;
    let interval = setInterval(() => {
      if (window.Kameleoon) {
        resolve();
      }
      if (window.Kameleoon || nbIterations >= 10) {
        clearInterval(interval);
        interval = null;
        if (!window.Kameleoon) {
          reject(new Error("Script Kameleoon introuvable"));
        }
      }
      nbIterations++;
    }, 200);
  });
};

export const getKameleoonExperimentVariation = (experimentId) => {
  if (window.Kameleoon) {
    const experiment = Kameleoon.API.Experiments.getById(experimentId);
    if (experiment) {
      Kameleoon.API.Experiments.trigger(experiment.id, false);
      if (experiment.associatedVariation) {
        return experiment.associatedVariation.id
      }
    }
  }
  return 0;
}